__turbopack_context__.v({
  "className": "tegner_f07d21e-module__2eJo9q__className",
  "variable": "tegner_f07d21e-module__2eJo9q__variable",
});
